// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { UserDef, UserRef, UserUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace UserActions {
  export class GetAllUser {
    static readonly type = '[User] GetAllUser';
    readonly type = GetAllUser.type;
  }
  export class InitUsers {
    static readonly type = '[User] InitUsers';
    constructor(public id?: string) {}
  }

  export class CloseUsersConnection {
    static readonly type = '[User] CloseUsersConnection';
    readonly type = CloseUsersConnection.type;
  }

  export class GetUserById {
    static readonly type = '[User] GetUserById';
    readonly type = GetUserById.type;
  }

  export class UpdateUser {
    static readonly type = '[User] UpdateUser';
    constructor(
      public userData: Partial<UserUpdateData>,
      public ref: UserRef,
    ) {}
  }

  export class UpdateUserResult {
    static readonly type = '[User] UpdateUserResult';
    constructor(public data: Array<TypesaurusCoreDoc<UserDef> | null | undefined>) {}
  }

  export class DeleteUser {
    static readonly type = '[User] DeleteUser';
    constructor(public refs: UserRef[]) {}
  }

  export class QueryUser {
    static readonly type = '[User] QueryUser';

    constructor(
      public filter: {
        query: AbstractQueryParams<UserDef>[];
      },
    ) {}
  }
  export class UserError {
    static readonly type = '[User] UserError';

    constructor(public error: Error) {}
  }
}
